// url de backend para administrador
export const urlServerAdmin = "https://tlsapiappmobile.solintels.com/apptls/admin/"; //url de backend para administrador

export const urlServerNotifications = "https://tlsapiappmobile.solintels.com/apptls/socio-notifications/"; //url de backend para general